var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"w-50"},[_c('form-component')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }